import { MasterDataService } from 'src/app/services/master-data.service';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-my-article-one-sixth-report',
  templateUrl: './my-article-one-sixth-report.component.html',
  styleUrls: ['./my-article-one-sixth-report.component.css'],
})
export class MyArticleOneSixthReportComponent implements OnInit {
  selectedDate;
  reportList;
  showReportDetail = false;
  ICAIRegDate;
  constructor(private masterDataService: MasterDataService) {}

  ngOnInit(): void {
    if(localStorage.getItem('userICAIRegistrationDate')!="null"){
      this.ICAIRegDate = moment(localStorage.getItem('userICAIRegistrationDate')).format(
        'DD-MMMM-YYYY'
      );
    }else{
      this.ICAIRegDate="";
    }
  }

  onViewReport() {
    var entryDate1 = new Date(
      this.selectedDate.year +
        '-' +
        this.selectedDate.month +
        '-' +
        this.selectedDate.day
    );
    console.log('entrydate', entryDate1);
    var formatDate = moment(entryDate1).format('YYYY-MM-DD');
    console.log('format date', formatDate);

    this.masterDataService
      .getOneSixthReport(localStorage.getItem('id'), formatDate)
      .subscribe((res) => {
        this.reportList = res;
        this.showReportDetail = true;
        console.log('reportList', res);
      });
  }
}
